import { Stack } from '@startuptools/ui/Stack';
import { ShareCapitalTable } from './components/ShareCapitalTable';
import { ShareClassesTable } from './components/ShareClassesTable';
import { ShareCapitalChangesTable } from './components/SccsTable';

export const CompanyShareCapital = () => {
  return (
    <Stack gap={3}>
      <Stack direction="row" alignItems="stretch" gap={2}>
        <Stack flex={1}>
          <ShareCapitalTable />
        </Stack>
        <Stack flex={1}>
          <ShareClassesTable />
        </Stack>
      </Stack>
      <ShareCapitalChangesTable />
    </Stack>
  );
};
